@if (!isLoading()) {
  <div class="list-container">
    <mat-selection-list
      class="selection-list"
      [hideSingleSelectionIndicator]="true"
      [multiple]="false"
      [disableRipple]="true">
      @for (item of data(); track item.id) {
        <mat-list-option class="selection-option" [value]="item.id">
          <lfw-online-order-list-item [order]="item" class="no-padding" (refreshOrders)="onRefreshOrders()" />
        </mat-list-option>
      }
    </mat-selection-list>
    @if (hasNoData()) {
      <p>{{ 'ORDERS.NO_ORDERS' | translate }}</p>
    }
  </div>
}
@if (isLoading()) {
  <div>
    <div>{{ 'ORDERS.LOADING' | translate }}</div>
  </div>
}
